import React from 'react';

const items = [
  { icon: '🏛️', text: 'MCIM Reg. I-124028-A' },
  { icon: '⭐', text: '4.9★ Google Rating' },
  { icon: '👥', text: 'Verified Patient Reviews' },
  { icon: '🌿', text: '15+ Panchakarma Treatments' },
];

const TrustBar = () => (
  <div className="trust-bar" data-testid="trust-bar">
    <div className="trust-bar-inner">
      {items.map((item, i) => (
        <React.Fragment key={item.text}>
          <div className="trust-item" data-testid={`trust-item-${i}`}>
            <span>{item.icon}</span>
            <span>{item.text}</span>
          </div>
          {i < items.length - 1 && <span className="trust-divider">|</span>}
        </React.Fragment>
      ))}
    </div>
  </div>
);

export default TrustBar;
